import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLayersBehind"><Path d="M5.75 19.25C4.09315 19.25 2.75 17.9069 2.75 16.25V9.75C2.75 8.09315 4.09315 6.75 5.75 6.75H18.25C19.9069 6.75 21.25 8.09315 21.25 9.75V16.25C21.25 17.9069 19.9069 19.25 18.25 19.25H5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M4.75 3.75H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLayersBehind;
